// Tiny dispatcher-console alert beep using the Web Audio API. No assets needed.
let ctx = null;

const getCtx = () => {
  if (typeof window === "undefined") return null;
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    ctx = new AC();
  }
  return ctx;
};

const KEY = "dispatch911_sound_enabled";

export const isSoundEnabled = () => {
  if (typeof window === "undefined") return true;
  const v = localStorage.getItem(KEY);
  return v === null ? true : v === "true";
};

export const setSoundEnabled = (v) => {
  if (typeof window === "undefined") return;
  localStorage.setItem(KEY, v ? "true" : "false");
};

// Two-tone tactical beep ~280ms total.
export const playCallAlert = () => {
  if (!isSoundEnabled()) return;
  const ac = getCtx();
  if (!ac) return;
  if (ac.state === "suspended") {
    ac.resume().catch(() => {});
  }
  const now = ac.currentTime;
  const tones = [
    { freq: 880, start: now, dur: 0.13, gain: 0.18 },
    { freq: 1320, start: now + 0.14, dur: 0.14, gain: 0.22 },
  ];
  tones.forEach(({ freq, start, dur, gain }) => {
    const osc = ac.createOscillator();
    const g = ac.createGain();
    osc.type = "square";
    osc.frequency.setValueAtTime(freq, start);
    g.gain.setValueAtTime(0, start);
    g.gain.linearRampToValueAtTime(gain, start + 0.01);
    g.gain.exponentialRampToValueAtTime(0.0001, start + dur);
    osc.connect(g);
    g.connect(ac.destination);
    osc.start(start);
    osc.stop(start + dur);
  });
};
